<script setup lang="ts">
import { onUnmounted } from "vue";
import { tapOutSide$ } from "@zyzgroup/core-web";
import Box from "./Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const emits = defineEmits<{
  (event: "outSide", e: HammerInput): void;
}>();

let s1;

const mount = (box) => {
  if (!s1) {
    s1 = tapOutSide$(box.el).subscribe((e) => {
      emits("outSide", e);
    });
  }
};

onUnmounted(() => {
  s1?.unsubscribe();
});

defineExpose({});
</script>

<template>
  <Box
    class="tap"
    display-type="empty"
    @mount="mount"
  >
    <slot></slot>
  </Box>
</template>

<style></style>
